import { JsonToMarkdownOptions } from './types';

/**
 * Converts a JSON object to markdown based on configuration
 * @param data - The JSON object to convert
 * @param options - Configuration options for the conversion
 * @returns Formatted markdown string
 */
export function json2md<T = object>(data: T, options: JsonToMarkdownOptions<T>): string {
  const { configs } = options;
  const sections: string[] = [];

  for (const config of configs) {
    const { property, format } = config;

    const value = data[property];

    // Skip if value is undefined/null and we're not including undefined
    if (value === undefined || value === null || typeof value === 'function') {
      continue;
    }

    sections.push(format(value));
  }

  return sections.join('\n');
}

// Re-export types and utilities
export * from './types';
export * from './utils';
